import { render, staticRenderFns } from "./EmailGrid.vue?vue&type=template&id=319b6eb4&"
import script from "./EmailGrid.vue?vue&type=script&lang=js&"
export * from "./EmailGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports